import { createReducer, on } from '@ngrx/store'
import { setMevo, setMevoId } from './mevo.actions'

export interface MevoState {
	value: boolean
	id: string
}

export const initialState: MevoState = {
	value: false,
	id: '',
}

export const mevoReducer = createReducer(
	initialState,
	on(setMevo, (state, { value }) => ({ ...state, value })),
	on(setMevoId, (state, { id }) => ({
		...state,
		id,
	}))
)
